import { createLightTheme } from '@fluentui/react-components';
import type { BrandVariants, Theme } from '@fluentui/react-components';

/**
 * Brand ramp anchored to the Figma V4.6 palette (classic Microsoft blue):
 * rest #0078D4, hover #106EBE, pressed #005A9E, darker #004578,
 * light tints #EFF6FC / #DEECF9 / #C7E0F4.
 */
const aitaBrand: BrandVariants = {
  10: '#001528',
  20: '#00223C',
  30: '#002E50',
  40: '#003A65',
  50: '#004578',
  60: '#005A9E',
  70: '#106EBE',
  80: '#0078D4',
  90: '#1182D4',
  100: '#2B88D8',
  110: '#4A9BDC',
  120: '#71AFE5',
  130: '#A4CCEC',
  140: '#C7E0F4',
  150: '#DEECF9',
  160: '#EFF6FC',
};

export const aitaLightTheme: Theme = {
  ...createLightTheme(aitaBrand),
  // Neutral text colors per the Figma V4.6 exports.
  // NF4 deviates from the export's #A19F9D: 2.6:1 on white fails WCAG 2.1 AA
  // (1.4.3) for the footer/hints/muted drill-down text — #767676 is the nearest
  // AA-compliant grey (4.54:1). Flagged to design (WI 763389 audit).
  colorNeutralForeground1: '#323130',
  colorNeutralForeground2: '#484644',
  colorNeutralForeground3: '#605E5C',
  colorNeutralForeground4: '#767676',
};
